import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button, Card, Col, Form, Row } from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { Text } from 'components/Form/Fields';
import { Checkbox } from 'components/Form/Fields';
import { STATES_BRAZIL } from 'utility/data-offiline';
import { SelectWihoutControl } from 'components/Form/Fields';
import { handleSendGeneric } from 'services/generic';
import { TableCity } from './table-city';
import { Notification } from 'notification/notification';
import { useParams } from 'react-router-dom';
import useForm from 'hooks/useForm';

const toRedirect = '/admin/route/';

export const FormRoute = () => {
  const { handleChange, values, setValue, handleChangeCheckbox } = useForm({
    name: '',
    enable: true,
  });

  const isMobileDevice = useMediaQuery({
    query: '(max-width: 990px)',
  });

  const handleCheckbox = () => {
    return isMobileDevice ? { marginLeft: '20px' } : { marginLeft: '30px' };
  };

  const [city, setCity] = useState();
  const [state, setState] = useState('');
  const [clients, setClients] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      handleLoadCities(id);
    }
  }, [id]);

  const handleLoadClients = (e) => {
    const cityToLoad = e.target.value;
    setCity(cityToLoad);
  };

  const handleLoadCities = async (id) => {
    if (id !== 'new') {
      const data = await handleSendGeneric(`/v1/route/find/${id}`, 'GET');
      setClients(data);
    }
  };

  const handleSaveNewCityOnRoute = async (e) => {
    e.preventDefault();
    if (state !== undefined) {
      const payload = {
        routeId: id === 'new' ? null : id,
        action: 'CREATE',
        name: city,
        state: state,
      };
      await handleSendGeneric(`/v1/route/action`, 'POST', payload);
      Notification(200);
      window.location.reload();
      return;
    }
    Notification(500, 'Informe o município/distrito para vincular a rota!');
  };

  const handleLoadCitiesByState = async (e) => {
    const rawState = e.target.value;
    setState(rawState);
  };

  return (
    <>
      <CustomForm
        nameForm={'Cadastro de Rota'}
        typeForm={'POST'}
        pathUrl={'/v1/route'}
        getValues={values}
        loadValues={setValue}
        toRedirect={toRedirect}
        forceRefreshPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <Text
                label={'Nome'}
                fieldName={'name'}
                placeholder={'Informe o nome'}
                onChange={handleChange}
                value={values?.name}
                size={4}
              />
              <Checkbox
                style={handleCheckbox()}
                setValue={setValue}
                field='enable'
                textEnable='Habilitado'
                textDisable='Desabilitado'
                onChange={handleChangeCheckbox}
                value={values.enable}
                size={2}
              />
            </Row>
            <Row></Row>
            {id === null ? null : (
              <>
                <Row>
                  <SelectWihoutControl
                    label={'Estado'}
                    size={2}
                    data={STATES_BRAZIL}
                    onChange={handleLoadCitiesByState}
                    value={state}
                  />
                  <Text
                    label={'Cidade'}
                    size={2}
                    onChange={handleLoadClients}
                    value={city}
                  />
                  <Col lg={2}>
                    <Button
                      style={{ marginTop: '32px' }}
                      color='primary'
                      size='md'
                      onClick={(e) => handleSaveNewCityOnRoute(e)}
                    >
                      Adicionar
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <div className='col'>
                    <Card className='shadow'>
                      {clients?.length > 0 && <TableCity data={clients} />}
                    </Card>
                  </div>
                </Row>
              </>
            )}
          </div>
        </Form>
      </CustomForm>
    </>
  );
};
